// extracted by mini-css-extract-plugin
export default {"work_section":"Work_work_section__ZsjZm","see_moreBtn":"Work_see_moreBtn__mkgNi","see_more":"Work_see_more__hDqIo"};